<template>
  <div class="order-price">
    <h1>
      <sup>¥</sup>
      <span>{{ price }}</span>
    </h1>
  </div>
</template>

<script>
export default {
  props: ["price"]
}
</script>

<style lang="scss" scoped>
.order-price {
  text-align: center;
  padding-top: 50px;
  @include avenir-demi();
}
</style>